const css = require('./slider.css');
const signals = require('../../../signals/order/slider');
const Message = require('./message');
const { cut } = require('../../../helpers/utils');

const CONTENT_SELECTOR = cut(css.wrapper);

class Slider {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.setIntervalSlider();

        return {
            click: {
                [CONTENT_SELECTOR]: this.onClickSlider
            }
        };
    }

    unbind () {
        clearInterval(this.intervalId);
    }

    onClickSlider () {
        this.$context.signal(signals.sliderNextView);
    }

    setIntervalSlider () {
        this.intervalId = setInterval(() => {
            this.$context.signal(signals.sliderNextView);
        }, 5000);
    }
}

module.exports = {
    constructor: Slider,
    children: [
        {
            name: 'message',
            component: Message,
            watcher: {
                title: ['slider', 'computed', 'text', 'title'],
                content: ['slider', 'computed', 'text', 'content']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/order/slider/index.js